import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class HostGalleryItem extends ThemeComponent {
    // Ref to store buttons and popup
    @Ref() openButton!: HTMLDivElement;
    @Ref() closeButton!: HTMLDivElement;
    @Ref() hostPopup!: HTMLDivElement;
    @Ref() popupWrapper!: HTMLDivElement;


    init() {
        this.openPopup();
        this.closeTrigger();
        this.closeOutside();
    }

    private openPopup() {
        if (this.openButton) {

            this.$listen(this.openButton, 'click', (event) => {
                if (this.hostPopup) {
                    this.hostPopup.classList.add('active');
                    document.body.classList.add('popup-active');
                }
            });
        }
    }

    private closeTrigger() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => {
                this.closePopup();
            });
        }
    }

    private closeOutside() {
        document.addEventListener('click', (event) => {
            const target = event.target as Node;
            if (
                this.hostPopup.classList.contains('active') && // Only close if popup is open
                !this.popupWrapper.contains(target) &&
                !this.openButton.contains(target)
            ) {
                this.closePopup();
            }
        });
    }



    private closePopup() {
        if (this.hostPopup) {
            this.hostPopup.classList.add('closing');
            this.hostPopup.addEventListener(
                'transitionend',
                () => {
                    this.hostPopup.classList.remove('closing', 'active');
                    document.body.classList.remove('popup-active');
                },
                { once: true }
            );

        }
    }
}
